import React, {useCallback, useEffect} from 'react';
import {ReactComponent as NoticeSvg} from '../../../assets/img/svgs/notice.svg';
import {useDispatch, useSelector} from "react-redux";
import {loadRemoteConfigs} from "../../../redux/slices/dynamicElementsSlice";
import {ComponentError} from "../../../components/ComponentLoader";
import CustomIcon from "../../../components/CustomIcon";

const NoticeBanner = ({mobile}) => {
  const dispatch = useDispatch();
  const {loading, data: {notice}={}, init, error} =
    useSelector((state) => state.dynamicElements.remoteConfigs);

  useEffect(() => {
    if (!init && !loading && !error)
      dispatch(loadRemoteConfigs());
  }, [dispatch, init, error, loading]);

  const retry = useCallback(
    () => {
      dispatch(loadRemoteConfigs());
    },
    [dispatch]
  );


  return (
    <div className="w-full app-top-mg app-side-pd bg-none text-dark">

      {loading ? <NoticeLoader/>
        : error ? <ComponentError className="h-20 rounded-lg" errorMsg={error} retry={retry}/>
          :
          <div className="bg-rose-200 app-rounded shadow-md">
            {notice?.active ? "" :
              <span className={`${mobile ? "text-xs p-2" : "text-base p-3"} font-semiBold text-error-500 flex whitespace-pre-wrap`}>  <CustomIcon className="mr-1" size={`${mobile ? "base" : "2xl"}`} icon="info_outline"/> Currently inactive. Activate the notice to make it visible in the app</span>}
            <div className={`flex ${mobile ? "p-4" : "py-5 px-24"} app-rounded items-center gradient-secondary`}>
              <div className={`bg-primaryApp rounded-full ${mobile ? "p-4" : "p-7"}`}>
                <NoticeSvg height={`${mobile ? 30 : 100}`} fill="white"/>
              </div>
              <div className={`${mobile ? "ml-2" : "ml-8"} space-y-1`}>
                <div className={`leading-none ${mobile ? "text-lg" : "text-[44px]"} font-bold`}>
                  Notice
                </div>
                <div className={`${mobile ? "text-xs" : "text-2xl"} whitespace-pre-wrap`}>{notice?.title_en}</div>
              </div>
            </div>
          </div>
          }

    </div>
  );
};

export default React.memo(NoticeBanner);

const NoticeLoader = () => {
  return (
    <div className="flex p-4 rounded animate-pulse bg-rand-200">
      <div className="bg-rand-300 rounded-full p-4 opacity-50">
        <NoticeSvg height={20} fill="grey"/>
      </div>
      <div className="flex flex-col justify-center ml-2 space-y-2 w-full">
        <div className="h-3 bg-rand-300 opacity-50">&nbsp;</div>
        <div className="h-2 bg-rand-300 opacity-50">&nbsp;</div>
      </div>

    </div>
  );
};
